<template>
  <div class="">
<!--    <div id="container" ref="qrCodeDiv2">-->
<!--      <div class="qrcode-container">-->
<!--        <div class="yinlian">-->
<!--          <img src="../../assets/jianguan.png"-->
<!--               style="width: 50px;height: 50px;"/>-->
<!--        </div>-->
<!--        <div class="name">顺民意监管码</div>-->
<!--      </div>-->
<!--      <div class="qrcode-center">-->
<!--        <div id="qrCode" class="qrcode" ref="qrCodeDiv" style="width: 200px;height: 200px;"></div>-->
<!--      </div>-->
<!--      <div class="text">{{item.name}}</div>-->
<!--      <div class="qrCode-footer">-->
<!--        <div class="pay-logo">-->
<!--        </div>-->
<!--        <div class="entitle">技术支持：西安顺民意集市管理有限责任公司</div>-->
<!--      </div>-->
<!--    </div>-->


    <div id="qrCode" class="qrcode" ref="qrCodeDiv" style="width: 200px;height: 200px;"></div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import html2canvas from 'html2canvas'

export default {
  name: "QrcodeView",
  data() {
    return {
      posterImg: '',
    }
  },
  props: {
    item: {},
    saveImage: {
      type: String,
      value: ''
    },
  },
  created() {

  },
  methods: {
    bindQRCode() {
      this.$refs.qrCodeDiv.innerHTML = "";
      new QRCode(this.$refs.qrCodeDiv, {
        text: 'http://www.smyjs.com/supervision?productId=' + this.item.id,
        // text: 'http:///192.168.3.201:8080/supervision?productId=' + this.item.id,
        width: 200,
        height: 200,
        scale: 2,
        colorDark: '#000000', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        correctLevel: QRCode.CorrectLevel.H// 容错率，L/M/H
      })

      // 延迟执行图片创建
      setTimeout(() => {
        this.createPicture();
      }, 200); // 确保二维码完全生成
    },
    createPicture() {
      this.$nextTick(() => {
        setTimeout(() => {
          html2canvas(this.$refs.qrCodeDiv, {
            backgroundColor: null,
            scale: 2,
            width: 230,
            useCORS: true, // 启用跨域支持
            allowTaint: true, // 允许污染画布
          }).then(canvas => {
            let imgData = canvas.toDataURL('image/png');
            this.$emit('update:saveImage', imgData);
          }).catch(error => {
            console.error('canvas转换失败:', error);
            this.$message.error('生成图片失败');
          });
        }, 100); // 给一点时间让二维码完全渲染
      });
    }
  }
}
</script>

<style scoped>
/*.container {*/
/*  width: 270px;*/
/*  border-radius: 10px;*/
/*  background: green;*/
/*  height: 400px;*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  flex-direction: column;*/
/*}*/
.yinlian {
  margin: 0 10px;
  width: 60px;
  height: 40px;
}

#container {
  width: 100%;
  /**background: #008cff;*/
  background: #0066FF;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.qrcode-container {
  width: 100%;
  padding: 20px;
  justify-content: center;
  border-bottom: 1px solid white;
  display: flex;
  align-items: center;
  flex-direction: row;
}

.qrcode-container .name {
  color: white;
  font-size: 30px;
  letter-spacing: 10px;
  font-weight: bold;
}

.qrcode-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  justify-content: center;
  margin-top: 20px;
  border-radius: 10px;
}

.qrcode-center .merchant-name {
  width: 100%;
  text-align: center;
  padding-bottom: 10px;
  font-size: 18px;
  background-color: white;
  font-weight: bold;
  color: #000000;
}

.text {
  margin: 20px 0;
  font-size: 18px;
  color: white;
  font-weight: bold;
}

.qrCode-footer {
  width: 100%;
  background-color: white;
}

.qrCode-footer .pay-logo {

  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.qrCode-footer .pay-logo img:not(:nth-child(5n)) {
  margin-right: 15px;
}

.qrcode {
  padding: 15px;
}

.entitle {
  color: #000000;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}

.productShare {
  width: 375px;
}

</style>
